<template>
  <div class="ban">
    <div class="ban1" v-if="one">
      <p>Orders will be processed automatically after setting the shipping method preferrence.</p>
      <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="preference"
      >Create shipping preference</el-button>
    </div>

    <el-card class="box-card" v-if="two">
      <div slot="header" class="clearfix">
        <span>Selection setup</span>
      </div>
      <div class="text item">
        <el-form class="roe" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent>
          <el-form-item style="display: inline-block; " prop="custom">
          <p>Please select shipping method :</p>
          <el-select v-model="ruleForm.custom" @change="fitcustom"  filterable  placeholder="Please choose" style="width:300px">
            <el-option
              v-for="item in ruleForm.Customs"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <a @click="Intelligent" style="color: #8989ba;cursor: pointer;">Intelligent recommendation</a>
          <a   @click="Channel" style="color: #8989ba;cursor: pointer;margin-left: 10px;">Channel price list</a>
        </el-form-item>

          <ul class="l_tree">
            <span
              style="position: absolute; left: -16px;top: 0;bottom: 0;margin: auto;height: 0px;color: #8989ba;font-size: 18px;"
            >if</span>

            <li class="l_tree_branch" v-for="(itim,index) in li" :key="index">
              <el-select
                v-model="itim.efcId"
                :disabled="itim.disabled"
                placeholder="Please choose"
                @change="onchange(itim.efcId)"
                style="width:30%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.efc_en_name"
                  :value="item.efc_id"
                  :disabled="item.disableds"
                ></el-option>
              </el-select>
              <el-form-item
                style="display: inline-block; width:60%"
                prop="countrys"
                v-if="itim.efcId==3"
              >
                <el-select
                  v-model="ruleForm.countrys"
                  filterable
                  multiple
                  placeholder="Please choose"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in ruleForm.Country"
                    :key="item.id"
                    :label="item.enName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                style="display: inline-block; width:60%"
                prop="accounts"
                v-if="itim.efcId==2"
              >
                <el-select
                  v-model="ruleForm.accounts"
                  filterable
                  multiple
                  placeholder="Please choose"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in ruleForm.Account"
                    :key="item.id"
                    :label="item.enName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                style="display: inline-block; width:60%"
                prop="skueparated"
                v-if="itim.efcId==1"
              >
                <el-input
                  type="skueparated"
                  placeholder="Separated by commas"
                  v-model="ruleForm.skueparated"
                  style="width:100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                style="display: inline-block; width:30%"
                prop="Wminvalue"
                v-if="itim.efcId==12"
              >
                <el-input
                  type="Wminvalue"
                  placeholder="Order weight Min value"
                  v-model="ruleForm.Wminvalue"
                  style="width:100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                style="display: inline-block; width:30%"
                prop="Wmaxvalue"
                v-if="itim.efcId==12"
              >
                <el-input
                  type="Wmaxvalue"
                  placeholder="Order weight Max value"
                  v-model="ruleForm.Wmaxvalue"
                  style="width:100%"
                ></el-input>
              </el-form-item>

              <el-form-item
                style="display: inline-block; width:30%"
                prop="lte"
                v-if="itim.efcId==10"
              >
                <el-input
                  type="lte"
                  placeholder="Invoiced Amount  Min value"
                  v-model="ruleForm.lte"
                  style="width:100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                style="display: inline-block; width:30%"
                prop="gte"
                v-if="itim.efcId==10"
              >
                <el-input
                  type="gte"
                  placeholder="Invoiced Amount  Max value"
                  v-model="ruleForm.gte"
                  style="width:100%"
                ></el-input>
              </el-form-item>
              <span style="float: right;">
                <i class="el-icon-delete" style="font-size:26px;color:red;" @click="remove(itim)"></i>
              </span>
            </li>

            <li class="l_tree_branch">
              <i class="el-icon-circle-plus" @click="add" style="font-size:26px;color:#8989ba"></i>
            </li>
          </ul>
        </el-form>
        <el-button
          style="background:#8989ba;color:#fff;outline: none"
          @click="Next('ruleForm')"
        >Next</el-button>
      </div>
    </el-card>

    <div v-if="Three" class="ban2">
      <el-form class="roe" :model="ThreeForm" :rules="rules1" ref="ThreeForm" @submit.native.prevent>
        <el-form-item prop="entername">
          <p>Please enter preference name :</p>
          <el-input
            type="entername"
            placeholder="Please enter preference name "
            v-model="ThreeForm.entername"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="priority">
          <p>Pleasae set up preference priority :</p>
          <el-select v-model="ThreeForm.priority" placeholder="Please choose" style="width:300px">
            <el-option
              v-for="item in ThreeForm.Prioritys"
              :key="item.ruleClass"
              :label="item.ruleClass"
              :value="item.ruleClass"
              :disabled="item.disableds"
            ></el-option>
          </el-select>
          <span>
            The number 1 has the highest priority, priority decreases as the
            number increases
          </span>
        </el-form-item>
      </el-form>
      <el-button style="background:#a6cbcb;color:#fff;outline: none" @click="Previous">Previous</el-button>
      <!-- <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="Next2('ThreeForm')"
      >Next</el-button>-->
      <el-button
        style="background:#8989ba;color:#fff;outline: none"
        @click="Submit('ThreeForm')"
      >Submit</el-button>
    </div>

    <el-dialog title="Intelligent recommendation" :visible.sync="dialogTableVisible" width="800px" :close-on-click-modal="false"
    :before-close="clearIntelligent">
      <el-form
        :inline="true"
        :model="formInline"
        style="text-align: left;"
        ref="formInline"
        label-width="150px"
        :rules="formInlinerules"
        @submit.native.prevent
      >
        <el-form-item label="Country destination :" prop="destination">
          <el-select
            v-model="formInline.destination"
            filterable
            placeholder="Please select"
            @change="Intelligentchange('formInline')"
          >
            <el-option
              v-for="item in destination"
              :key="item.enName"
              :label="item.enName"
              :value="item.enName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Order weight:" prop="weight">
          <el-select v-model="formInline.weight" placeholder="Please select" @change="Intelligentchange('formInline')">
            <el-option
              v-for="item in weight"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Include Battery:" prop="Cell">
          <el-select v-model="formInline.Cell"   placeholder="Please select" @change="Intelligentchange('formInline')">
            <el-option
              v-for="item in Cell"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Channel preference:" prop="preference">
          <el-select v-model="formInline.preference" placeholder="Please select" @change="Intelligentchange('formInline')">
            <el-option
              v-for="item in preference1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="formInline.preference==''||formInline.Cell==''||formInline.weight==''||formInline.destination==''">
        <img src="./nodata.png" alt style="display: inline-block;width: 250px;">
        <p
          style="color:#333333;margin-top: 10px;"
        >Please set up your filters and then the recommended shipping methods will appear.</p>
      </div>
      <div v-else>
        <el-table :data="gridData" v-loading="loading">
          <el-table-column property="ship_method" label="Channel code"></el-table-column>
          <el-table-column property="classtype" label="Type"></el-table-column>
          <el-table-column property="esfd_shiptime" label="Average time"></el-table-column>
          <el-table-column property="shipfee" label="EstimateFreight" width="150"></el-table-column>
          <el-table-column property="rate_index" label="Recommend" width="150">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.rate_index" disabled show-score text-color="#ff9900"></el-rate>
            </template>
          </el-table-column>
          <el-table-column property="address" label="Operation">
            <template slot-scope="scope">
              <a style="color: #8989ba;cursor: pointer;" @click="recommendation(scope)">select</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getruletype,
  getcolvals,
  getshippriority,
  addrule, recommendshipmethod
} from '../api/setting'
import { getcountry, gettokenuser } from '../api/user'
import { getToken, setToken } from '../../utils/auth'
import store from '@/store'
export default {
  data () {
    var checkamount = (rule, value, callback) => {
      console.log(value)
      console.log(rule)
      if (!value) {
        return callback(new Error('The amount cannot be empty'))
      }
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(Number(value))) {
        callback(new Error('please enter a number'))
      } else {
        callback()
      }
    }
    return {
      formInline: { destination: '', Cell: '', preference: '', weight: '' },
      li: [{ efcId: '1' }],
      rules: {
        skueparated: [
          { required: true, message: 'Sku cannot be empty', trigger: 'blur' }
        ],
        accounts: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        countrys: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        Custom: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        custom: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],

        gte: [{ validator: checkamount, trigger: 'blur' }],
        lte: [{ validator: checkamount, trigger: 'blur' }],
        Wminvalue: [{ validator: checkamount, trigger: 'blur' }],
        Wmaxvalue: [{ validator: checkamount, trigger: 'blur' }]
      },
      formInlinerules: {
        destination: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        weight: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        Cell: [{ required: true, message: 'Please choose', trigger: 'change' }],
        preference: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ]
      },
      rules1: {
        priority: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        custom: [
          { required: true, message: 'Please choose', trigger: 'change' }
        ],
        entername: [
          {
            required: true,
            message: 'Please enter preference name',
            trigger: 'blur'
          }
        ]
      },
      rules2: {
        CNY: [
          {
            required: true,
            message: 'Please enter preference name',
            trigger: 'blur'
          }
        ]
      },
      gridData: [],
      two: false,
      one: true,
      Three: false,
      Four: false,
      loading: true,
      dialogTableVisible: false,
      options: [],
      ruleForm: {
        accounts: [],
        countrys: [],
        Customs: [],
        Country: [],
        Account: [],
        alldata: '',
        skueparated: '',
        Wminvalue: '',
        Wmaxvalue: '',
        lte: '',
        gte: '',
        custom: ''
      },
      ThreeForm: {

        Prioritys: [],
        resource: 62,

        priority: '',
        entername: ''
      },
      weight: [
        {
          value: '10',
          label: '10g'
        },
        {
          value: '20',
          label: '20g'
        },
        {
          value: '50',
          label: '50g'
        },
        {
          value: '100',
          label: '100g'
        },
        {
          value: '150',
          label: '150g'
        },
        {
          value: '200',
          label: '200g'
        }
      ],
      Cell: [
        {
          value: '1',
          label: 'YES'
        },
        {
          value: '2',
          label: 'NO'
        }
      ],
      preference1: [
        {
          value: '1',
          label: 'Speed priority'
        },
        {
          value: '2',
          label: 'comprehensive'
        },
        {
          value: '3',
          label: 'Economic priority'
        }
      ],
      destination: [],
      FourForm: { applicable: 1, priority: 1, pending: 1 }
    }
  },

  mounted () {
    let param = {
      id: 50,
      warehouse_id: 18,
      sp_code: 'CFF'
    }
    getcolvals(param)
      .then(response => {
        console.log(response)
        if (response.data.ask == 1) {
          let Customs = []
          for (let i = 0; i < Object.keys(response.data.data).length; i++) {
            let arr =
              response.data.data[Object.keys(response.data.data)[i]].data
            arr.forEach(function (value, index) {
              Customs.push(value)
            })
          }
          this.ruleForm.Customs = Customs
        }
      })
      .catch(error => {
        console.log(error)
      })

    if (this.$route.params.new) {
      this.one = false
      this.two = true
    }

    getruletype()
      .then(response => {
        console.log(response)
        if (response.data.ask == 1) {
          this.alldata = response.data.alldata

          let param = {
            id: 50,
            warehouse_id: 18
          }
          getcolvals(param)
            .then(response => {
              console.log(response)
              if (response.data.ask == 1) {
                let alldata = ''
                for (let i = 0; i < this.alldata.length; i++) {
                  for (let j = 0; j < response.data.cond.length; j++) {
                    if (
                      this.alldata[i].efc_id == response.data.cond[j].efc_sub_id
                    ) {
                      if (
                        this.alldata[i].efc_id != '8'
                      ) {
                        console.log(this.alldata[i].efc_id)
                        if (this.alldata[i].efc_id == 10) {
                          let Amount = {
                            efc_id: '10',
                            efc_cn_name: 'Invoiced Amount',
                            efc_en_name: 'Invoiced Amount',
                            efc_column: 'lte'
                          }
                          this.options.push(Amount)
                        } else if (this.alldata[i].efc_id == 12) {
                          let weight = {
                            efc_id: '12',
                            efc_cn_name: 'Order weight',
                            efc_en_name: 'Order weight',
                            efc_column: 'lte'
                          }
                          this.options.push(weight)
                        } else if (
                          this.alldata[i].efc_id != 13 &&
                          this.alldata[i].efc_id != 11
                        ) {
                          this.options.push(this.alldata[i])
                        }
                      }
                    }
                  }
                }
                console.log(this.options)
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
      .catch(error => {
        console.log(error)
      })

    getshippriority()
      .then(response => {
        console.log(response)
        if (response.data.ask == 1) {
          var prioritys
          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].used == 1) {
              prioritys = response.data.data[i]
              prioritys.disableds = true
              this.ThreeForm.Prioritys.push(prioritys)
            } else {
              this.ThreeForm.Prioritys.push(response.data.data[i])
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  methods: {
    preference () {
      this.one = false
      this.two = true
    },
    fitcustom () {
      this.ruleForm.countrys = []

      let param = {
        id: 3,
        colType: 2,
        warehouse_id: 18,
        efcValue: this.ruleForm.custom
      }

      getcolvals(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            console.log(response.data.data)

            this.ruleForm.countrys = []
            let countrys = []
            for (
              let i = 0;
              i < Object.keys(response.data.data).length;
              i++
            ) {
              let arr =
                    response.data.data[Object.keys(response.data.data)[i]].data
              arr.forEach(function (value, index) {
                countrys.push(value)
              })
            }
            console.log(countrys)
            this.ruleForm.Country = countrys
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    Intelligent () {
      console.log(111)
      this.dialogTableVisible = true
      // if(this.ruleForm.countrys.length>0)

      let param = {
        id: 3,
        colType: 2,
        warehouse_id: 18
      }
      getcolvals(param)
        .then(response => {
          console.log(response)
          if (response.data.ask == 1) {
            let countrys = []
            for (let i = 0; i < Object.keys(response.data.data).length; i++) {
              let arr =
                response.data.data[Object.keys(response.data.data)[i]].data
              arr.forEach(function (value, index) {
                countrys.push(value)
              })
            }
            console.log(this.ruleForm)
            if (this.ruleForm.countrys.length > 0) {
              let countryss = []
              for (let i = 0; i < this.ruleForm.countrys.length; i++) {
                for (let j = 0; j < countrys.length; j++) {
                  if (this.ruleForm.countrys[i] == countrys[j].id) {
                    countryss.push(countrys[j])
                  }
                }
              }
              this.destination = countryss
            } else {
              this.destination = countrys
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    clearIntelligent () {
      this.$refs['formInline'].resetFields()
      this.dialogTableVisible = false
    },
    Channel () {
      let param = {
        customer_id: store.getters.shopTokenuser.customer_id,
        secretkey: '3d878b3aeae9d5d389a7c82a27708c6a'
        //
      }
      gettokenuser(param)
        .then(response => {
          this.loading = false
          if (response.data.ask == 1) {
            document.cookie =
              'token=' +
              response.data.token +
              ';path=/;domain=.sendfromchina.com'
            window.open(
              'http://www.sendfromchina.com/logistics/analyzing?division_id=14&country2=United+States+Of+America&length=1&width=1&height=1&user_type=1'
            )
          }
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    Intelligentchange (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          console.log(this.formInline)
          let param = {
            country: this.formInline.destination,
            weight: this.formInline.weight,
            channel: this.formInline.preference,
            is_battery: this.formInline.Cell
          }
          recommendshipmethod(param)
            .then(response => {
              console.log(response)
              this.loading = false
              if (response.data.ask == 1) {
                this.gridData = response.data.data
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    recommendation (scope) {
      console.log(scope)
      this.$refs['formInline'].resetFields()
      this.ruleForm.custom = scope.row.ship_method
      this.fitcustom()
      this.dialogTableVisible = false
    },
    Submit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm)
          console.log(this.ThreeForm)
          console.log(this.FourForm)
          let opsku = []
          opsku.push(this.ruleForm.skueparated)
          let lte = []
          lte.push(this.ruleForm.lte)
          let gte = []
          gte.push(this.ruleForm.gte)
          let w_lte = []
          w_lte.push(this.ruleForm.Wminvalue)
          let w_gte = []
          w_gte.push(this.ruleForm.Wmaxvalue)
          let efcValue = this.ruleForm.custom
          let param = {
            active: 1,
            ruleStatus: 2,
            ruleClass: this.ThreeForm.priority,
            ruleWarehouse: 4,
            ruleShipPart: 'CFF',
            efcId: 50,
            efcValue: efcValue,
            opsku_type: 0,
            ruleName: this.ThreeForm.entername,
            lte: lte,
            gte: gte,
            w_lte: w_lte,
            w_gte: w_gte
          }
          if (this.ruleForm.Wmaxvalue != '') {
            param.rd_weights = 1
          }
          if (this.ruleForm.lte != '') {
            param.rd_sums = 1
          }
          if (this.ruleForm.countrys.length > 0) {
            param.country = this.ruleForm.countrys
            for (let i = 0; i < this.options.length; i++) {
              if (
                (this.options[i].efc_id == '3')
              ) {
                param.rd_country = this.options[i].efc_id
              }
            }
          }
          if (this.ruleForm.accounts.length > 0) {
            param.account = this.ruleForm.accounts
            for (let i = 0; i < this.options.length; i++) {
              if (
                (this.options[i].efc_id == '2')
              ) {
                param.rd_account = this.options[i].efc_id
              }
            }
            // param.rd_account = this.ruleForm.accounts.length;
          }
          if (this.ruleForm.skueparated != '') {
            param.opsku = opsku
            for (let i = 0; i < this.options.length; i++) {
              if ((this.options[i].efc_id == '1')) {
                param.rd_opsku = this.options[i].efc_id
              }
            }
          }
          console.log(param)
          // let param = {
          //   active:1,
          //   ruleStatus: 2,
          //   ruleClass: this.ThreeForm.priority,
          //   ruleWarehouse: 4,
          //   ruleShipPart: "CFF",
          //   efcId: this.ThreeForm.resource,
          //   efcValue: efcValue,
          //   opsku_type: 0,
          //   ruleName: this.ThreeForm.entername,
          //   rd_opsku: 1,
          //   opsku: opsku,
          //   lte: lte,
          //   gte: gte,
          //   w_lte: w_lte,
          //   w_gte: w_gte,
          //   country: this.ruleForm.countrys,
          //   rd_country: this.ruleForm.countrys.length,
          //   rd_account: this.ruleForm.accounts.length,
          //   account: this.ruleForm.accounts
          // };
          addrule(param)
            .then(response => {
              console.log(response)
              if (response.data.ask == 1) {
                this.$router.push({ path: '/Setting' })
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },

    Previous () {
      this.Three = false
      this.two = true
    },
    Previous1 () {
      this.Four = false
      this.Three = true
    },
    Next (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm.lte != '') {
            if (this.ruleForm.lte > this.ruleForm.gte) {
              this.$message({
                type: 'warning',
                message: 'The maximum order amount should not be less than the minimum'
              })
              return
            }
          }
          if (this.ruleForm.Wminvalue != '') {
            if (this.ruleForm.Wminvalue > this.ruleForm.Wmaxvalue) {
              this.$message({
                type: 'warning',
                message: 'The maximum of weight must not be less than the minimum.'
              })
              return
            }
          }
          this.two = false
          this.Three = true
          console.log(this.ruleForm)
        }
      })
    },
    Next2 (formName) {
      console.log(formName)
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.Four = true
          this.Three = false
          console.log(this.ruleForm)
        }
      })
    },
    resource () {
      if (this.ThreeForm.resource == 50) {
        this.ruleForm.custom = ''
        console.log(this.ThreeForm.resource)
        let param = {
          id: this.ThreeForm.resource,
          warehouse_id: 18,
          sp_code: 'CFF'
        }
        getcolvals(param)
          .then(response => {
            console.log(response)
            if (response.data.ask == 1) {
              let Customs = []
              for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                let arr =
                  response.data.data[Object.keys(response.data.data)[i]].data
                arr.forEach(function (value, index) {
                  Customs.push(value)
                })
              }
              this.ruleForm.Customs = Customs
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
      }
    },
    onchange (vua) {
      console.log(vua)

      if (vua == 2 || vua == 3) {
        let param = {
          id: vua,
          colType: 2,
          warehouse_id: 18
        }
        if (vua == 3) {
          if (this.ruleForm.custom != '') {
            param.efcValue = this.ruleForm.custom
          } else {
            this.$message.error('Please choose the mode of transportation first.')
            return
          }
        }
        getcolvals(param)
          .then(response => {
            console.log(response)
            if (response.data.ask == 1) {
              console.log(response.data.data)
              if (vua == 3) {
                this.ruleForm.countrys = []
                let countrys = []
                for (
                  let i = 0;
                  i < Object.keys(response.data.data).length;
                  i++
                ) {
                  let arr =
                    response.data.data[Object.keys(response.data.data)[i]].data
                  arr.forEach(function (value, index) {
                    countrys.push(value)
                  })
                }
                this.ruleForm.Country = countrys
              } else if (vua == 2) {
                this.ruleForm.accounts = []
                let countrys = []
                for (
                  let i = 0;
                  i < Object.keys(response.data.data).length;
                  i++
                ) {
                  let arr =
                    response.data.data[Object.keys(response.data.data)[i]].data
                  arr.forEach(function (value, index) {
                    countrys.push(value)
                  })
                }

                this.ruleForm.Account = countrys
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else if (vua == 10) {
        this.ruleForm.gte = ''
        this.ruleForm.lte = ''
      } else if (vua == 12) {
        this.ruleForm.Wminvalue = ''
        this.ruleForm.Wmaxvalue = ''
      }
    },
    add () {
      console.log(this.li)
      if (this.li[this.li.length - 1].efcId == undefined) {
        this.$message({
          type: 'warning',
          message: 'Please choose first.'
        })
      } else {
        this.li[this.li.length - 1].disabled = true
        for (let i = 0; i < this.options.length; i++) {
          if (this.li[this.li.length - 1].efcId == this.options[i].efc_id) {
            console.log(this.options[i].efc_id)
            this.options[i].disableds = true
          }
        }
        if (this.li.length == 4) {
          this.$message({
            type: 'warning',
            message: 'Up to 4.'
          })
        } else {
          this.li.push({})
        }
      }
    },
    remove (itim) {
      if (itim.efcId != undefined) {
        for (let i = 0; i < this.options.length; i++) {
          if (itim.efcId == this.options[i].efc_id) {
            console.log(this.options[i].efc_id)
            this.options[i].disableds = false
          }
        }
      }
      if (this.li.length != 1) {
        var index = this.li.indexOf(itim)

        if (index !== -1) {
          if (this.li[index].efcId == '2') {
            this.ruleForm.accounts = []
          } else if (this.li[index].efcId == '3') {
            this.ruleForm.countrys = []
          } else if (this.li[index].efcId == '1') {
            this.ruleForm.skueparated = ''
          } else if (this.li[index].efcId == '10') {
            this.ruleForm.lte = ''
            this.ruleForm.gte = ''
          } else if (this.li[index].efcId == '12') {
            this.ruleForm.Wmaxvalue = ''
            this.ruleForm.Wminvalue = ''
          }

          this.li.splice(index, 1)
        }
      } else {
        this.$message({
          type: 'warning',
          message: 'At least one.'
        })
      }
    }
  }
}
</script>
<style scoped>
.ban {
  margin: 20px;
  padding: 20px;
  height: 600px;
}
.ban .ban1 {
  height: 80px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 70%;
}
.ban1 p {
  padding: 10px;
}
.box-card {
  text-align: left;
}
ul,
li {
  list-style: none;
}
.ban2 {
  width: 900px;
  margin: 0 auto;
  padding: 10px;
  background: #fff;
  text-align: left;
}
.l_tree {
  width: calc(80% - 44px);
  height: 100%;
  padding-left: 42px;
  position: relative;
  margin: 0 auto;
}
ul.l_tree:before {
  content: "";
  border-left: 1px solid #eee;
  height: calc(100%);
  position: absolute;
  left: 10px;
  top: 35px;
}
.l_tree .l_tree_branch:last-child::before {
  content: "";
  width: 3px;
  height: calc(100% - 0px);
  display: block;
  background-color: #ffffff;
  position: absolute;
  bottom: -36px;
  left: -34px;
}
.l_tree_branch::after {
  content: "";
  width: 40px;
  height: 0;
  border-bottom: 1px solid #eee;
  position: absolute;
  right: calc(100% - 9px);
  top: 35px;
}
.l_tree_branch {
  width: 100%;
  height: 100%;
  display: block;
  padding: 13px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Setting/settingyi.vue